import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, staggerContainer } from '../utils/constants';
export function Team() {
  const team = [{
    name: 'Dr. Martín Velasco',
    role: 'Socio Fundador',
    specialty: 'Derecho Penal y Constitucional',
    exp: '25 años de experiencia',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80'
  }, {
    name: 'Dra. Carolina Méndez',
    role: 'Socia Directora',
    specialty: 'Derecho Civil y Comercial',
    exp: '18 años de experiencia',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80'
  }, {
    name: 'Dr. Sebastián Ríos',
    role: 'Asociado Senior',
    specialty: 'Derecho Laboral',
    exp: '12 años de experiencia',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80'
  }, {
    name: 'Dra. Valentina Torres',
    role: 'Asociada',
    specialty: 'Derecho de Familia y Sucesiones',
    exp: '8 años de experiencia',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80'
  }];
  return <section id="equipo" className="py-32 bg-white relative border-y border-grayMid" data-id="element-184">
      <div className="max-w-7xl mx-auto px-6" data-id="element-185">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} data-id="element-186">
          <motion.div variants={fadeUp} className="text-center mb-20" data-id="element-187">
            <h2 className="heading-brutalist text-4xl md:text-5xl mb-6 text-grayDarkest" data-id="element-188">
              NUESTRO EQUIPO
            </h2>
            <p className="text-xl text-grayDarkest font-light" data-id="element-189">
              Profesionales comprometidos con la excelencia jurídica
            </p>
            <div className="w-24 h-px bg-grayDarkest mx-auto mt-8" data-id="element-190"></div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-191">
            {team.map((member, index) => <motion.div key={index} variants={fadeUp} className="group" data-id="element-192">
                <div className="bg-white border border-grayMid p-6 flex flex-col items-center text-center hover:shadow-lg transition-shadow duration-300 h-full" data-id="element-193">
                  <div className="w-full aspect-[3/4] overflow-hidden mb-6 relative" data-id="element-194">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-195" />
                  </div>

                  <h3 className="font-montserrat text-xl font-bold mb-2 uppercase text-grayDarkest" data-id="element-196">
                    {member.name}
                  </h3>
                  <p className="text-grayDarkest text-sm font-semibold tracking-widest uppercase mb-4" data-id="element-197">
                    {member.role}
                  </p>

                  <div className="w-full h-px bg-grayMid mb-4" data-id="element-198"></div>

                  <p className="text-grayDarkest font-light text-sm mb-2" data-id="element-199">
                    {member.specialty}
                  </p>
                  <p className="text-grayMedium text-xs uppercase tracking-wider font-semibold" data-id="element-200">
                    {member.exp}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}